import { render, staticRenderFns } from "./TownLocation.vue?vue&type=template&id=3e9bcea4&"
import script from "./TownLocation.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TownLocation.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9bcea4')) {
      api.createRecord('3e9bcea4', component.options)
    } else {
      api.reload('3e9bcea4', component.options)
    }
    module.hot.accept("./TownLocation.vue?vue&type=template&id=3e9bcea4&", function () {
      api.rerender('3e9bcea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/TownLocation.vue"
export default component.exports